import { render, staticRenderFns } from "./GameItem.vue?vue&type=template&id=07eff693&scoped=true&"
import script from "./GameItem.vue?vue&type=script&lang=js&"
export * from "./GameItem.vue?vue&type=script&lang=js&"
import style0 from "./GameItem.vue?vue&type=style&index=0&id=07eff693&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eff693",
  null
  
)

export default component.exports